import { useCallback } from "react";
import { container } from "tsyringe";
import { XMarkIcon } from "@heroicons/react/20/solid";
import ProjectTeamCastResponseResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastResponseResource";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Modal from "components/elements/Modal";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { useProjectTeamContext } from "components/pages/ProfessionalSpace/contexts/ProjectTeam";
import { useProjectId } from "hooks/useProjectId";
import CastService from "services/projects/CastService";
import { formatContributorName } from "utils/UserUtils";
import classes from "./classes.module.scss";

type IProps = {
	cast: ProjectTeamCastResponseResource;
	isOpen: boolean;
	onClose: () => void;
	onDeleted: (deletedCast: Pick<ProjectTeamCastResponseResource, "id">) => void;
};

const castService = container.resolve(CastService);

export default function DeleteCastingModal(props: IProps) {
	const { projectId } = useProjectId();
	const { projectTeamId } = useProjectTeamContext();

	const onDeleteCasting = useCallback(() => {
		castService.delete(projectId, projectTeamId, props.cast.id).then(() => props.onDeleted(props.cast));
	}, [projectId, projectTeamId, props]);

	return (
		<Modal isOpen onClose={props.onClose} className={classes["root"]}>
			<div className={classes["header"]}>
				<Typography type="p" size="large" weight="bold">
					{I18n.asset.pages.professional_space.tabs.casting.delete_casting_modal.title}
				</Typography>
				<XMarkIcon className={classes["icon"]} onClick={props.onClose} />
			</div>

			<div className={classes["text-container"]}>
				<Typography type="p">
					{I18n.trslt(I18n.asset.pages.professional_space.tabs.casting.delete_casting_modal.text_1, { name: formatContributorName(props.cast.actor) })}
				</Typography>
				<Typography type="p">{I18n.asset.pages.professional_space.tabs.casting.delete_casting_modal.text_2}</Typography>
			</div>

			<div className={classes["buttons-container"]}>
				<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={props.onClose}>
					{I18n.asset.pages.professional_space.tabs.casting.delete_casting_modal.cancel}
				</Button>
				<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} onClick={onDeleteCasting}>
					{I18n.asset.pages.professional_space.tabs.casting.delete_casting_modal.confirm}
				</Button>
			</div>
		</Modal>
	);
}
